import React from "react";
import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";

const ResetCartPopup = ({ show, onHide, handleResetCart }) => {
  const [showLoading, setShowLoading] = useState(false);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={isMobile ? { fontSize: "20px" } : {}}>
          Start a new service selection?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to remove the workshop? This action will clear
          existing items from your cart.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            sessionStorage.removeItem("get-fitting-at-home");
            sessionStorage.removeItem("tyreProduct");
            handleResetCart(setShowLoading);
          }}
        >
          Remove
          {showLoading ? (
            <Spinner
              animation="grow"
              role="status"
              className={!isMobile ? "ml-2" : ""}
              size="sm"
            >
              <span className="visually-hidden"></span>
            </Spinner>
          ) : null}
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Go back
          {/* <Spinner
            animation="grow"
            role="status"
            className={!isMobile ? "ml-2" : ""}
            size="sm"
          >
            <span className="visually-hidden"></span>
          </Spinner> */}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetCartPopup;
